// extracted by mini-css-extract-plugin
export default {"url":"url-url-vNZPLY"};